import { useScrollReveal } from "../../../hooks/useScrollReveal";
import "./Cta02.css";

import Button01 from "../../core/Button01";

function Cta02() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`Cta02 section section-reveal ${isVisible ? "section--visible" : ""}`}
      id="Cta02"
    >
      <div className="container">
        <div className="Cta02-box">
          <h2>Ready to reclaim your digital real estate?</h2>
          <p>
            Secure your revenue. Claim your status. Submit your profile for
            consideration today.
          </p>
          <Button01 />
        </div>
      </div>
    </div>
  );
}

export default Cta02;
